var map = {
	"./BorderRadius.vue": "9907",
	"./BorderWidth.vue": "0f43",
	"./Colors.vue": "ee61",
	"./FontSizes.vue": "5234",
	"./FontWeight.vue": "70bf",
	"./Height.vue": "e211",
	"./LetterSpacing.vue": "2b80",
	"./LineHeight.vue": "68f4",
	"./MaxHeight.vue": "6812",
	"./MaxWidth.vue": "1e22",
	"./MinHeight.vue": "e3f7",
	"./MinWidth.vue": "bd10",
	"./Opacity.vue": "f7f9",
	"./Screens.vue": "a36e",
	"./Shadows.vue": "e9d1",
	"./Spacing.vue": "47a5",
	"./Transitions.vue": "efaf",
	"./Width.vue": "87b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c79b";